import React from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Column from '~/Common-Objects/Grids/Column/Column'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import Row from '~/Common-Objects/Grids/Row/Row'
import NumberFunction from '~/Classes/numberFormatFunctions'
import i18n from '~/i18n'

export default function SmsSendGroupSubscribers({ campaign, subscriberCount, save = () => { } }) {

    return (
        <Paper className="mar-b20">
            <Row>
                <Column xs={12}>
                    {<h4 className="mar-b25">{i18n.t('campaigns:main.noOfRecipients')}</h4>}
                    <div className="quickFlex" style={{ justifyContent: "space-between", alignItems: "center" }}>
                        <div className="text-lg2 text-heavy cyt-view-total-subs" >{!!subscriberCount ? NumberFunction.formatNumber(subscriberCount) : 0}</div>
                        <Button className='cyt-view-total-btn' text={i18n.t('campaigns:main.viewRecipients')} onClick={() => save()} />
                    </div>
                </Column>
            </Row>
        </Paper>
    )

}